import { render, staticRenderFns } from "./EntityStatistic.vue?vue&type=template&id=b43431be&scoped=true&"
import script from "./EntityStatistic.vue?vue&type=script&lang=js&"
export * from "./EntityStatistic.vue?vue&type=script&lang=js&"
import style0 from "./EntityStatistic.vue?vue&type=style&index=0&id=b43431be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43431be",
  null
  
)

export default component.exports